import React from "react";

export const Mercury = () => {
  return (
    <div>
      <div
        id={"mercury"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};